import styled from 'styled-components'

export default styled.div`
  padding: 0px 20px 20px 40px;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-content: flex-start;
  flex-direction: column;
`